import ShareFeedbackSegment from './ShareFeedbackSegment';

export default ShareFeedbackSegment;
